import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const SPECIAL_CHAR = /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]~`]/;

export interface PasswordChecks {
  minLength: boolean;
  mixedCase: boolean;
  number: boolean;
  specialChar: boolean;
}

export interface PasswordStrength {
  score: number;
  label: '' | 'WEAK' | 'MEDIUM' | 'STRONG';
}

export function getPasswordChecks(value: string | null | undefined): PasswordChecks {
  const password = value ?? '';
  return {
    minLength: password.length >= 8,
    mixedCase: /[a-z]/.test(password) && /[A-Z]/.test(password),
    number: /\d/.test(password),
    specialChar: SPECIAL_CHAR.test(password),
  };
}

export function getPasswordStrength(value: string | null | undefined): PasswordStrength {
  if (!value) return { score: 0, label: '' };

  const passed = Object.values(getPasswordChecks(value)).filter(Boolean).length;
  if (passed <= 1) return { score: passed, label: 'WEAK' };
  if (passed <= 3) return { score: passed, label: 'MEDIUM' };
  return { score: passed, label: 'STRONG' };
}

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value ?? '';
    if (!value) return null;

    const checks = getPasswordChecks(value);
    return checks.minLength && checks.mixedCase && checks.number && checks.specialChar
      ? null
      : { weakPassword: true };
  };
}

export function passwordsMatchValidator(group: AbstractControl): ValidationErrors | null {
  const password = group.get('password')?.value;
  const confirmPassword = group.get('confirmPassword')?.value;

  if (!password || !confirmPassword) return null;
  return password === confirmPassword ? null : { passwordMismatch: true };
}
